import { Component, OnInit, SimpleChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Modal } from 'ngx-modal';

@Component({
  selector: 'dac-client-dialog',
  templateUrl: './client-dialog.component.html',
  styleUrls: ['./client-dialog.component.scss']
})
export class ClientDialogComponent implements OnInit {

  @ViewChild('modal') modal: Modal;
  @Input() isOpen:boolean;
  @Output() close:EventEmitter<void>;

  constructor() {
    this.close = new EventEmitter<void>();
   }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    
    if (this.isOpen && !this.modal.isOpened) {
      this.modal.open();
    }
    else if (!this.isOpen && this.modal.isOpened) {
      this.modal.close();
    }
  }


  handleClose() {
    this.close.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/client-dialog/client-dialog.component.ts